import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { TRC_BOOK_START, OWLY_INTERSTITIAL } from '../../../constants/url';
import selectors from '../../../rootSelectors';
import TROInstructionsView from './TROInstructionsView';
import {
    clearPermissionsError,
    clearRecordedResult,
    clearRecordingStream,
    setPermissionsError,
    setRecordingStream,
} from '../../../common/recording/recordingActions';
import { goTo, goToStartPage } from '../../../common/navigation/navigationActions';
import { showHelpPopup, hideHelpPopup } from '../../../common/screen/screenActions';
import { logUserOut } from '../../../common/user/userActions';
import {
    setCompletedStepIndex,
    setCurrentStepIndex,
    setProgressStepsCount,
    setPreviouslyEnabledMic,
} from '../../trcActions';
import {
    trackTroError,
    trackPressedRestartButton,
    trackFailedEnableMic,
    trackStartPreAssessmentStep,
    trackNextPreAssesmentStep,
} from '../../trcReporting';
import { narrateReset } from '../../../common/audio/audioActions';
import { startTimeTracking } from '../../../common/timeTracking/timeTrackingActions';
import { TRO_PRE_ASSESSMENT_STEPS } from '../../../common/timeTracking/timeTrackingKeys';

const mapStateToProps = state => ({
    period: selectors.getToy(state),
    userId: selectors.getUserId(state),
    grade: selectors.getGrade(state),
    isScreenBlocked: selectors.getIsScreenBlocked(state),
    didPermissionsFail: selectors.didPermissionsFail(state),
    isHelpPopupVisible: selectors.getIsHelpPopupVisible(state),
    onboardingProgressBar: selectors.getOnboardingProgressBar(state),
    areAllDemoVideosWatched: selectors.areAllDemoVideosWatched(state),
    isRecordingInProgress: selectors.getIsRecordingInProgress(state),
    isExternalURLSourcePresent: selectors.getExternalURLSourceStatus(state),
    isBenchmarkModeEnabled: selectors.getisBenchmarkModeEnabled(state),
});

const mapDispatchToProps = dispatch => ({
    goToStart: (isExternalURLSourcePresent = true) => {
        if (!isExternalURLSourcePresent) dispatch(trackPressedRestartButton());
        dispatch(goToStartPage());
        dispatch(clearRecordingStream());
    },
    showHelpPopup: () => dispatch(showHelpPopup()),
    hideHelpPopup: () => dispatch(hideHelpPopup()),
    goToNextPage: () => dispatch(goTo(TRC_BOOK_START)),
    setCompletedStepIndex: stepIndex => dispatch(setCompletedStepIndex(stepIndex)),
    setCurrentStepIndex: stepIndex => dispatch(setCurrentStepIndex(stepIndex)),
    setProgressStepsCount: stepsCount => dispatch(setProgressStepsCount(stepsCount)),
    setRecordingStream: recordingStream => dispatch(setRecordingStream(recordingStream)),
    onPermissionsError: permissionsError => dispatch(setPermissionsError(permissionsError)),
    clearPermissionsError: permissionsError => dispatch(clearPermissionsError(permissionsError)),
    onMicTestRetry: () => {
        dispatch(clearRecordedResult());
        dispatch(hideHelpPopup());
        dispatch(narrateReset());
    },
    logUserOut,
    goToOwlyInterstitial: () => dispatch(goTo(OWLY_INTERSTITIAL)),
    trackTroError: problem =>
        dispatch(trackTroError(`Clicked Continue without microphone. Reason: ${problem}`)),
    trackFailedEnableMic: () => dispatch(trackFailedEnableMic()),
    trackStartPreAssessmentStep: section => dispatch(trackStartPreAssessmentStep(section)),
    trackNextPreAssesmentStep: section => dispatch(trackNextPreAssesmentStep(section)),
    setPreviouslyEnabledMic: () => dispatch(setPreviouslyEnabledMic()),
    startPreAssessmentTimeTracking: () => dispatch(startTimeTracking(TRO_PRE_ASSESSMENT_STEPS)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TROInstructionsView));
